import type {ReactNode, MouseEventHandler} from 'react'
import {Button} from '@/components/ui/button'
import {cn} from '@/lib/utils'

interface CompactButtonProps {
    children: ReactNode
    onClick?: MouseEventHandler<HTMLButtonElement>
    variant?: 'ghost' | 'outline' | 'default'
    size?: 'xs' | 'sm'
    disabled?: boolean
    type?: 'button' | 'submit'
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses = {
    xs: 'h-6 px-1.5 text-xs',
    sm: 'h-7 px-2 text-xs',
}
/* eslint-enable i18next/no-literal-string */

export function CompactButton({
    children,
    onClick,
    variant = 'ghost',
    size = 'sm',
    disabled,
    type = 'button',
    className,
    'data-testid': testId,
}: CompactButtonProps) {
    return (
        <Button
            variant={variant}
            size="sm"
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={cn(sizeClasses[size], className)}
            data-testid={testId}
        >
            {children}
        </Button>
    )
}
